<ng-container>
  <div class="wrapper__form">
    <app-form
      [fields]="formFieldsReclamoDirecto"
      [title]="sfcText['tramite-sic-procon']['reclamo-directo']"
      [titleModalVisibility]="true"
      [titleContentModalText]="
        sfcText['sfc-procon']['reclamo-proveedor']
      "
      [tooltipVisibility]="true"
      [tooltipMessage]="sfcText['tramite-sic-procon']['clic-aca']"
      [titleSizeModal]="'xl'"
      [titleModal]="'comun-label.ver-mas' | translate"
      (changeAction)="validarFormulario($event)"
      (changedControl)="validarCampos($event)"
      [withSubmitButton]="false"
      [idEntidad]="entidadId"
    />
    <div class="wrapper__form">
      <div class="col-12 col-xl-12 mb-3">
        <app-cargue-archivos-tramite
          *ngIf="getFilesPrecargadosByPaso(5).length > 0"
          [archivosPreCargados]="getFilesPrecargadosByPaso(5)"
          [paso]="5"
          [idTipoTramite]="entidadId"
          [idTramite]="tramiteSfc?.id!"
          [btnEnviar]="false"
          [enviar]="enviarDocumentos"
          [enviarEntidad]="enviar"
          (archivosObligatoriosPasos)="getFileRequeridos($event)"
          (guardo)="subirArchivo($event)"
          (archivosCargados)="validarArchivosCargados($event, 5)"
          [nombreCortoTramite]="nombreTramite">
        </app-cargue-archivos-tramite>
        <app-cargue-archivos-tramite
          *ngIf="getFilesPrecargadosByPaso(5).length == 0"
          [archivosPreCargados]="getFilesPrecargadosByPaso(5)"
          [paso]="5"
          [idTipoTramite]="entidadId"
          [idTramite]="tramiteSfc?.id!"
          [btnEnviar]="false"
          [enviar]="enviarDocumentos"
          [enviarEntidad]="enviar"
          (archivosObligatoriosPasos)="getFileRequeridos($event)"
          (guardo)="subirArchivo($event)"
          (archivosCargados)="validarArchivosCargados($event, 5)"
          [nombreCortoTramite]="nombreTramite">
        </app-cargue-archivos-tramite>
        <div class="mt-3 text-muted small d-flex align-items-center">
          <i class="bi bi-info-circle me-2"></i>
          {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        type="submit"
        class="btn-govco fill-before-btn-govco w-auto"
        onClick="nextItemAdvanceLineIHorizonalBack(event)"
        (click)="atras()"
        [attr.aria-label]="sfcText['botones-envio']['atras']">
        {{ sfcText['botones-envio']['atras'] }}
      </button>

      <button
        type="button"
        class="btn-govco fill-btn-govco w-auto"
        (click)="pasarANotificaciones($event, true)"
        [attr.aria-label]="sfcText['botones-envio']['guardar-sin-enviar']">
        {{ sfcText['botones-envio']['guardar-sin-enviar'] }}
      </button>

      <button
        type="submit"
        class="btn-govco fill-next-btn-govco w-auto"
        (click)="pasarANotificaciones($event, false)"
        [attr.aria-label]="sfcText['siguiente']">
        {{ sfcText['siguiente'] }}
      </button>
    </div>
  </div>
</ng-container>